import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoImg from "../assets/logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage the menu visibility

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the state
  };

  return (
    <nav className="fixed top-0 z-20 w-full bg-gray-100 bg-opacity-10 backdrop-blur-sm shadow-lg rounded-b-[15px]">
      <div className="flex justify-between items-center px-4 md:px-8 lg:px-16">
        {/* Logo Section */}
        <div className="flex items-center">
          <Link to='/'>   <img
            src={logoImg} 
            alt="Food Licence logo"
            className="h-[50px] w-[50px] md:h-[90px] md:w-[90px]"
          /></Link>
         
        </div>

        {/* Navigation Links */}
        <ul className="hidden md:flex gap-x-10 font-medium text-slate-950">
          <li>
            <Link
              to="/"
              className="text-lg hover:text-orange-500 transition duration-300"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/services"
              className="text-lg hover:text-orange-500 transition duration-300"
            >
              Services
            </Link>
          </li>
          <li>
            <Link
              to="/aboutus"
              className="text-lg hover:text-orange-500 transition duration-300"
            >
              About Us
            </Link>
          </li>
        </ul>
        <div></div>

        {/* Mobile Menu Toggle Button */}
        <div className="md:hidden">
          <button
            id="menu-toggle"
            onClick={toggleMenu}
            className="text-slate-950 text-xl focus:outline-none"
          >
            ☰
          </button>
        </div>
      </div>

      {/* Dropdown Menu for Mobile */}
      {isMenuOpen && ( // Conditional rendering based on state
        <div
          id="mobile-menu"
          className="md:hidden flex flex-col gap-y-3 py-4 px-6 bg-white shadow-lg rounded-b-[15px] text-slate-950"
        >
          <Link
            to="/"
            onClick={() => setIsMenuOpen(false)} // Close the menu on link click
            className="text-lg hover:text-orange-500 transition duration-300"
          >
            Home
          </Link>
          <Link
            to="/services"
            onClick={() => setIsMenuOpen(false)} // Close the menu on link click
            className="text-lg hover:text-orange-500 transition duration-300"
          >
            Services
          </Link>
          <Link
            to="/aboutus"
            onClick={() => setIsMenuOpen(false)} // Close the menu on link click
            className="text-lg hover:text-orange-500 transition duration-300"
          >
            About Us
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
